import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  HttpClientModule,
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientJsonpModule,
} from "@angular/common/http";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { PaginationModule, TabsModule } from "ngx-bootstrap";
import { ShareButtonModule } from "@ngx-share/button";
import { AngularFireModule } from "angularfire2";
import { AngularFirestoreModule } from "angularfire2/firestore";
import { HttpModule } from "@angular/http";

import { ModalModule } from "ngx-bootstrap/modal";
import { TagInputModule } from "ngx-chips";
import { AlertModule } from "ngx-bootstrap";
import { AppComponent } from "./app.component";
import { routing } from "./app.routing";
import { AlertComponent } from "./_directives/index";
import { AuthGuard } from "./_guards/index";
import { JwtInterceptor } from "./_helpers/index";
import {
  AlertService,
  AuthenticationService,
  UserService,
  ChatService,
} from "./_services/index";
import { HomeComponent } from "./authorized-data/home/index";
import { LoginComponent } from "./login/index";
import { FooterComponent } from "./footer/footer.component";
import { HomeSerachComponent } from "./home-serach/home-serach.component";
import { DashboardHeaderComponent } from "./authorized-data/dashboard-header/dashboard-header.component";
import { DashboardSidemenuComponent } from "./authorized-data/dashboard-sidemenu/dashboard-sidemenu.component";
import { ForgotPasswordComponent } from "./forgot-password/forgot-password.component";
import { CookieService } from "ngx-cookie-service";
import { PostMusicComponent } from "./authorized-data/post-music-listing/post-music/post-music.component";
import { SignupComponent } from "./signup/signup.component";
import { ForbiddenValidatorDirective } from "./shared/forbidden-name.directive";
import { TokenService } from "./_services/token/token.service";
import { AdvtService } from "./_services/advt.service";
import { PusherService } from "./_services/pusher.service";
// import { NgxPayPalModule } from "ngx-paypal";
import { AgmCoreModule } from "@agm/core";
import { NgxGalleryModule } from "ngx-gallery";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatInputModule, MatNativeDateModule } from "@angular/material";
import { RatingModule } from "ngx-rating";
import { SimpleNotificationsModule } from "angular2-notifications";
import { StripeInformationComponent } from "./stripe-information/stripe-information.component";

import { ImageUploadModule } from "angular2-image-upload";
import { UploadFileService } from "./_services/upload-file.service";
import { PostMusicEditComponent } from "./authorized-data/post-music-listing/post-music-edit/post-music-edit.component";
import { PostBookComponent } from "./authorized-data/post-book-listing/post-book/post-book.component";
import { PostGraphicsComponent } from "./authorized-data/post-graphics-listing/post-graphics/post-graphics.component";
import { PostServicesComponent } from "./authorized-data/post-services-listing/post-services/post-services.component";
import { PostStuffComponent } from "./authorized-data/post-stuff-listing/post-stuff/post-stuff.component";
import { PostVideosComponent } from "./authorized-data/post-videos-listing/post-videos/post-videos.component";
import { PostMusicListingComponent } from "./authorized-data/post-music-listing/post-music-listing.component";
import { TermconditionComponent } from "./pages/termcondition/termcondition.component";
import { PostingrulesComponent } from "./pages/postingrules/postingrules.component";
import { PostAllComponent } from "./authorized-data/post-music-listing/post-all/post-all.component";
import { TokenInterceptor } from "./_helpers/token.interceptor";
import { PostBookListingComponent } from "./authorized-data/post-book-listing/post-book-listing.component";
import { PostBookHomeComponent } from "./authorized-data/post-book-listing/post-book-home/post-book-home.component";
import { PostGraphicsListingComponent } from "./authorized-data/post-graphics-listing/post-graphics-listing.component";
import { PostGraphicsHomeComponent } from "./authorized-data/post-graphics-listing/post-graphics-home/post-graphics-home.component";
import { PostServicesListingComponent } from "./authorized-data/post-services-listing/post-services-listing.component";
import { PostServicesHomeComponent } from "./authorized-data/post-services-listing/post-services-home/post-services-home.component";
import { PostStuffListingComponent } from "./authorized-data/post-stuff-listing/post-stuff-listing.component";
import { PostStuffHomeComponent } from "./authorized-data/post-stuff-listing/post-stuff-home/post-stuff-home.component";
import { PostVideosListingComponent } from "./authorized-data/post-videos-listing/post-videos-listing.component";
import { PostVideoHomeComponent } from "./authorized-data/post-videos-listing/post-video-home/post-video-home.component";
import { DetailItemComponent } from "./authorized-data/detail-item/detail-item.component";
import { SellerInfoComponent } from "./authorized-data/seller-info/seller-info.component";
import { SendRequestComponent } from "./authorized-data/send-request/send-request.component";
import { ReceiveRequestComponent } from "./authorized-data/receive-request/receive-request.component";
import { BidAcceptComponent } from "./authorized-data/bid-accept/bid-accept.component";
import { PendingPurchaseComponent } from "./authorized-data/pending-purchase/pending-purchase.component";
import { ItemHistoryComponent } from "./authorized-data/item-history-sold/item-history.component";
import { ItemHistoryBoughtComponent } from "./authorized-data/item-history-bought/item-history-bought.component";
import { RatingDialogComponent } from "./rating-dialog/rating-dialog.component";
import { NotificationComponent } from "./authorized-data/notification/notification.component";
import { PostBookEditComponent } from "./authorized-data/post-book-listing/post-book-edit/post-book-edit.component";
import { PostGraphicsEditComponent } from "./authorized-data/post-graphics-listing/post-graphics-edit/post-graphics-edit.component";
import { PostServicesEditComponent } from "./authorized-data/post-services-listing/post-services-edit/post-services-edit.component";
import { PostStuffEditComponent } from "./authorized-data/post-stuff-listing/post-stuff-edit/post-stuff-edit.component";
import { PostVideosEditComponent } from "./authorized-data/post-videos-listing/post-videos-edit/post-videos-edit.component";
import { ServiceProviderListComponent } from "./authorized-data/post-services-listing/service-provider-list/service-provider-list.component";
import { ServicePaymentComponent } from "./authorized-data/service-payment/service-payment.component";
import { BidItemUpdateComponent } from "./authorized-data/bid-item-update/bid-item-update.component";
import { ServicePaymentRequestComponent } from "./authorized-data/service-payment-request/service-payment-request.component";
import { UserComponent } from "./authorized-data/user/user.component";
import { UserProfileComponent } from "./authorized-data/user/user-profile/user-profile.component";
import { UserProfileEditComponent } from "./authorized-data/user/user-profile-edit/user-profile-edit.component";
import { HelpInfoComponent } from "./pages/help-info/help-info.component";
import { RadioListComponent } from "./authorized-data/radio-list/radio-list.component";
import { ProfileComponent } from "./profile/profile.component";
import { ChatComponent } from "./authorized-data/chat/chat.component";
import { ServiceRequestsComponent } from "./authorized-data/service-requests/service-requests.component";
import { ChangePasswordComponent } from "./authorized-data/user/change-password/change-password.component";
import { SearchAlertsComponent } from "./authorized-data/search-alerts/search-alerts.component";
import { TradeHomeComponent } from "./authorized-data/trade/trade-home/trade-home.component";
import { TradeAddComponent } from "./authorized-data/trade/trade-add/trade-add.component";
import { TradeEditComponent } from "./authorized-data/trade/trade-edit/trade-edit.component";
import { TradeRequestSentComponent } from "./authorized-data/trade/trade-request-sent/trade-request-sent.component";
import { TradeRequestRecievedComponent } from "./authorized-data/trade/trade-request-recieved/trade-request-recieved.component";
import { TradeDetailComponent } from "./authorized-data/trade/trade-detail/trade-detail.component";
import { MyTradeComponent } from "./authorized-data/trade/my-trade/my-trade.component";
import { TradeChatComponent } from "./authorized-data/trade/trade-chat/trade-chat.component";
import { TradeHistoryComponent } from "./authorized-data/trade/trade-history/trade-history.component";
import { TradAlertComponent } from "./authorized-data/trade/trad-alert/trad-alert.component";
import { TermsConditionsComponent } from "./authorized-data/terms-conditions/terms-conditions.component";
import { FreeHomeComponent } from "./authorized-data/free/free-home/free-home.component";
import { DashboardFreeSidemenuComponent } from "./authorized-data/dashboard-free-sidemenu/dashboard-free-sidemenu.component";
import { MyFreeComponent } from "./authorized-data/free/my-free/my-free.component";
import { FreeAddComponent } from "./authorized-data/free/free-add/free-add.component";
import { FreeEditComponent } from "./authorized-data/free/free-edit/free-edit.component";
import { FreeChatComponent } from "./authorized-data/free/free-chat/free-chat.component";
import { FreeRequestSentComponent } from "./authorized-data/free/free-request-sent/free-request-sent.component";
import { FreeDetailComponent } from "./authorized-data/free/free-detail/free-detail.component";
import { FreeDetailItemComponent } from "./authorized-data/free-detail-item/free-detail-item.component";
import { FreeRequestRecievedComponent } from "./authorized-data/free/free-request-recieved/free-request-recieved.component";
import { FreeAlertComponent } from "./authorized-data/free/free-alert/free-alert.component";
import { FreeHistoryComponent } from "./authorized-data/free/free-history/free-history.component";
import { FreeRequestDetailComponent } from "./authorized-data/free/free-request-detail/free-request-detail.component";
import { FreeHistoryDetailComponent } from "./authorized-data/free/free-history-detail/free-history-detail.component";
import { ChatServiceComponent } from './authorized-data/chat-service/chat-service.component';
import { PrivacyConditionsComponent } from './authorized-data/privacy-conditions/privacy-conditions.component';
import { CognitoService } from "./_services/Cognito.service";
import { ToastService } from "./_services/toast.service";
import { GetuserService } from "./_services/getuser.service";

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

/*const firebaseConfig = {
  apiKey: 'AIzaSyBMK4TLMfp0pWDQV39Eo6VDe7Lh9C3TIzI',
  authDomain: 'firestore-1994.firebaseapp.com',
  databaseURL: 'https://firestore-1994.firebaseio.com',
  projectId: 'firestore-1994',
  storageBucket: 'firestore-1994.appspot.com',
  messagingSenderId: '801844516425'

};*/

/*const firebaseConfig = {
    apiKey: "AIzaSyDuUaX2XITh1eJHpkYKnGhI27ngn0m4u9Q",
    authDomain: "bidj-30351.firebaseapp.com",
    databaseURL: "https://bidj-30351.firebaseio.com",
    projectId: "bidj-30351",
    storageBucket: "bidj-30351.appspot.com",
    messagingSenderId: "247072948243"

};*/

// const firebaseConfig = {
//   //    apiKey: 'AIzaSyDuUaX2XITh1eJHpkYKnGhI27ngn0m4u9Q',
//   apiKey: "AIzaSyDuUaX2XITh1eJHpkYKnGhI27ngn0m4u9Q",
//   authDomain: "bidj-30351.firebaseapp.com",
//   databaseURL: "https://bidj-30351.firebaseio.com",
//   projectId: "bidj-30351",
//   storageBucket: "bidj-30351.appspot.com",
//   messagingSenderId: "247072948243",
// };

const firebaseConfig = {
  apiKey: "AIzaSyAp37Sz3qKi3zx3cBR_kcRRvfHKtFhU2bo",
  authDomain: "bidjones-13f3a.firebaseapp.com",
  databaseURL: "https://bidjones-13f3a.firebaseio.com",
  projectId: "bidjones-13f3a",
  storageBucket: "bidjones-13f3a.appspot.com",
  messagingSenderId: "972190562444",
  appId: "1:972190562444:web:a1d8dc0ce56f19ac5023a9",
  measurementId: "G-5721JJ3QBT"
};

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    NgbModule.forRoot(),
    routing,
    // NgxPayPalModule,
    ReactiveFormsModule,
    PaginationModule.forRoot(),
    ImageUploadModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    HttpClientJsonpModule,
    NgxGalleryModule,
    ShareButtonModule.forRoot(),
    SimpleNotificationsModule.forRoot(),
    AgmCoreModule.forRoot({
      // apiKey: "AIzaSyCHya_w4gpL56pkjiLgjiZEIvKnL2Pivfw", //old
      apiKey: "AIzaSyAytvEH1v5VqbYMGrjBCkvFLT5JKjHs6ww", // new
      libraries: ["places"],
    }),
    TagInputModule,
    ModalModule.forRoot(),
    MatInputModule,
    MatNativeDateModule,
    MatInputModule,
    RatingModule,
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFirestoreModule,
    TabsModule.forRoot(),
  ],
  declarations: [
    AppComponent,
    AlertComponent,
    HomeComponent,
    LoginComponent,
    FooterComponent,
    HomeSerachComponent,
    DashboardHeaderComponent,
    DashboardSidemenuComponent,
    ForgotPasswordComponent,
    PostMusicComponent,
    SignupComponent,
    ForbiddenValidatorDirective,
    PostMusicEditComponent,
    PostBookComponent,
    PostGraphicsComponent,
    PostServicesComponent,
    PostStuffComponent,
    PostVideosComponent,
    PostMusicListingComponent,
    TermconditionComponent,
    PostingrulesComponent,
    PostAllComponent,
    PostBookListingComponent,
    PostBookHomeComponent,
    PostGraphicsListingComponent,
    PostGraphicsHomeComponent,
    PostServicesListingComponent,
    PostServicesHomeComponent,
    PostStuffListingComponent,
    PostStuffHomeComponent,
    PostVideosListingComponent,
    PostVideoHomeComponent,
    DetailItemComponent,
    SellerInfoComponent,
    SendRequestComponent,
    ReceiveRequestComponent,
    BidAcceptComponent,
    PendingPurchaseComponent,
    ItemHistoryComponent,
    ItemHistoryBoughtComponent,
    NotificationComponent,
    PostBookEditComponent,
    PostGraphicsEditComponent,
    PostServicesEditComponent,
    PostStuffEditComponent,
    PostVideosEditComponent,
    RatingDialogComponent,
    ServiceProviderListComponent,
    ServicePaymentComponent,
    BidItemUpdateComponent,
    ServicePaymentRequestComponent,
    UserComponent,
    UserProfileComponent,
    UserProfileEditComponent,
    HelpInfoComponent,
    RadioListComponent,
    ProfileComponent,
    ChatComponent,
    ServiceRequestsComponent,
    ChangePasswordComponent,
    SearchAlertsComponent,
    TradeHomeComponent,
    TradeAddComponent,
    TradeEditComponent,
    TradeRequestSentComponent,
    TradeRequestRecievedComponent,
    TradeDetailComponent,
    MyTradeComponent,
    TradeChatComponent,
    TradeHistoryComponent,
    TradAlertComponent,
    TermsConditionsComponent,
    StripeInformationComponent,
    FreeHomeComponent,
    DashboardFreeSidemenuComponent,
    MyFreeComponent,
    FreeAddComponent,
    FreeEditComponent,
    FreeChatComponent,
    FreeRequestSentComponent,
    FreeDetailComponent,
    FreeDetailItemComponent,
    FreeRequestRecievedComponent,
    FreeAlertComponent,
    FreeHistoryComponent,
    FreeRequestDetailComponent,
    FreeHistoryDetailComponent,
    ChatServiceComponent,
    PrivacyConditionsComponent,
  ],
  providers: [
    PusherService,
    TokenService,
    AuthGuard,
    AlertService,
    AuthenticationService,
    CookieService,
    AdvtService,
    JwtInterceptor,
    UploadFileService,
    ChatService,
    UserService,
    CognitoService,
    ToastService,
    GetuserService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
  entryComponents: [RatingDialogComponent],
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts